import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	listItemText: {
		color: colors.getPrimaryColor(),
		fontWeight: 500
	},
	listItemIcon: {
		minWidth: "inherit",
		width: 22,
		color: "inherit",
		marginRight: theme.spacing(1),
		fontSize: 18
	},
	menuItemTitle: {
		padding: theme.spacing(0.75, 2, 0),
		width: "100%",
		height: 44
	},
	"@keyframes textEnhancementPulse": {
		"0%, 100%": { opacity: 1 },
		"50%": { opacity: 0.5 }
	},
	pulseAnimation: {
		animation: "$textEnhancementPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
	}
}))

export default useStyles
